import { Aggregator } from './aggregator';

/**
 * Aggregator that calculates the average of the added values.
 */
export class MinMaxAverage extends Aggregator<number | undefined> {
  private values: number[] = [];

  private readonly multiplier: number;

  constructor(
    private readonly defaultValue?: number | undefined,
    private readonly precision = 4,
  ) {
    super();
    this.multiplier = Math.pow(10, this.precision);
  }

  getAggregated(): {
    min: number | undefined;
    max: number | undefined;
    average: number | undefined;
  } {
    const sum = this.values.reduce((acc, value) => acc + value, 0);

    if (sum === 0) {
      return {
        average: this.defaultValue,
        min: this.defaultValue,
        max: this.defaultValue,
      };
    }

    const average =
      Math.round((sum / this.values.length) * this.multiplier) /
      this.multiplier;

    const min =
      Math.round(Math.min(...this.values) * this.multiplier) / this.multiplier;
    const max =
      Math.round(Math.max(...this.values) * this.multiplier) / this.multiplier;

    return {
      average: average,
      min: min,
      max: max,
    };
  }

  reset(): void {
    this.values = this.defaultValue ? [this.defaultValue] : [];
  }

  protected _add(value: number | undefined): void {
    if (Number.isNaN(value) || value === undefined) {
      return;
    }

    this.values.push(value);
  }
}
